// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3197":"29f17776","5202":"daf2524e","8175":"afe2f7f1"}[chunkId] + ".chunk.css";
};